/**
 * ? @description : Unmapped Students Data Component
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";
import { ShowListInTooltip } from "../../../../Reusable/ShowListInTooltip";

import { Typography } from "@mui/material";
import { ShowFullText } from "../../../../Reusable/ShowMoreText";
import axios from "axios";



const ShowFullTextRenderer = (props) => {
  const { value } = props;
  // console.log(value);
  return (
    <ShowFullText title={value}>
      <Typography variant='p' sx={{ cursor: "pointer" }}>
        {value && value.length > 25 ? `${value.substring(0, 50)}... ` : value}
      </Typography>
    </ShowFullText>
  );
};
const ShowFullTextRendererStudentName = (props) => {
  const { value } = props;
  // console.log(value);
  return (
    <ShowFullText title={value}>
      <Typography variant='p' sx={{ cursor: "pointer" }}>
        {value && value.length > 25 ? `${value.substring(0, 50)}... ` : value}
      </Typography>
    </ShowFullText>
  );
};


function UnmappedStudentsTable(props) {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [filterData, setFilterData] = useState([]);
  const [studentCount, setStudentCount] = useState([]);

  // * Column Definition for the Table Data
  const columnHeader = [
    {
      headerName: "Student Id",
      field: "student_id",
      filter: true,
      sortable: true,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      hide: true,
    },
     {
       headerName: "",
       checkboxSelection: true,
       headerCheckboxSelection: true,
     },
    {
      headerName: "Student Name",
      field: "student_name",
      // filter: true,
      sortable: true,
      cellRendererFramework:'showFullTextRendererStudent'
    },
    {
      headerName: "No. of teachers Mapped",
      field: "teacher_count",
      // filter: true,
      sortable: true,
      cellRenderer: (params) => {
        let id = params.data.student_id
        return (
          params.value !== 0 ? <ShowListInTooltip value={params.value} getUrl={`mapping/map/checkmappingstudent/${id}`} property="teacher_name"></ShowListInTooltip> : "(0)"
        )
      }
    },
    {
      headerName: "Student Languages",
      field: "studentlanguages",
      // filter: true,
      sortable: true,
      cellRendererFramework: 'showFullTextRenderer',
    },
    {
      headerName: "Mobile",
      field: "class_contactno",
      // filter: true,
      sortable: true,
    },
    // {headerName: "Education", field: "education", filter: true, sortable: true},
    // {headerName: "Age", field: "student_age", filter: true, sortable: true},
    // {headerName: "Batch Id", field: "group_id", filter: true, sortable: true},
    // {headerName: "Batch Status", field: "group_status", filter: true, sortable: true},
    // {headerName: "Batch Name", field: "batch_name", filter: true, sortable: true},
    // {headerName: "Student Status", field: "student_status", filter: true, sortable: true},
    // {headerName: "Sponsor Name", field: "sponser_name", filter: true, sortable: true},
    // {headerName: "Sponsor Number", field: "sponser_contactno", filter: true, sortable: true}
  ];
  // * to show the full language in row 
  const components = {
    showFullTextRenderer: ShowFullTextRenderer, // register the custom renderer
    showFullTextRendererStudent: ShowFullTextRendererStudentName,

  };

  // * Row Selection - Multiple
  const rowSelectionType = "multiple";

  // * Store Selected Row Data in Props
  const onSelectionChanged = (event) => {
    props.unmappedstudentsdata(event.api.getSelectedRows());
  };

  // * Input Field : Search Box Data
  const onFilterTextChange = (e) => {
    filterData.setQuickFilter(e.target.value);
  };

  // ? Get Method : Data Initializing for the Table
  const onGridReady = async (params) => {
    setFilterData(params.api);
    const controller = axios.CancelToken.source();
    try {

      const response = await Axios("get", "/student/unmappedstudents", true, null, { cancelToken: controller.token });
      // console.log(response);
      const teacherCountData = await Axios("get", "mapping/display/teachercount", true, null, { cancelToken: controller.token });
      // const overallData = await Promise.all(
      //   response.data.map(async (obj) => {
      //     const fetch = await Axios("get", `mapping/map/checkmappingstudent/${obj.student_id}`, true, null)
      //     return {...obj, teacher_count: Number(fetch.data.resultdata.length), mapped_teachers: fetch.data.resultdata}
      //   })
      // )
      // console.log(overallData);
      let overallData = response.data.map(studentItem => {
        const index = teacherCountData.data.findIndex(teacherItem => teacherItem.student_id === studentItem.student_id)
        return index !== -1 ?
          {
            ...studentItem,
            ...teacherCountData.data[index]
          } :
          {
            ...studentItem,
            teacher_count: 0
          }
      })
      // console.log(overallData);
      params.api.applyTransaction({ add: overallData });
    } catch (error) {
      if(!axios.isCancel(error)){
        console.log(error);
        dispatch(
          showSnackbar({
            message: "Error occurred ! Unable to get students data.",
            severity: "error",
          })
        ); 
      }

    }
    return () => {
      controller.cancel();
  }
  };


  // * Function Call to Get the Count of the Students
  useEffect(() => {
    // ? Get Method : Get the Count of the Students from the Server
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        let options = {
          method: "GET",
          url: "/mapping/unmappedstudentscount",
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );
       setStudentCount(response.data)
        
      } catch (error) {
        if(!axios.isCancel(error)) {
          dispatch(
            showSnackbar({
              message: "Error occurred ! Unable to get students count.",
              severity: "error",
            })
          );
        }
       
      }
    })()
   
    return () => {
      controller.cancel();
  }
  }, [dispatch, props.reloadComments]);

  const studentsCount = () => (
    <p style={{ fontWeight: "600" }}>{studentCount[0]?.total_students}</p>
  );
  return (
    <div>
      {/* Search Box, Count, Title */}
      <div style={{ alignItems: 'center' }} className="d-flex justify-content-between my-2 table-header">
        <input
          type="search"
          placeholder="Search"
          onChange={onFilterTextChange}
        />
        <h5 style={{ margin: '0px', display: "flex" }} > Students ({studentsCount()}) </h5>
        {studentCount.length > 0 && (

          <h6 style={{ display: "flex", margin: "0px", alignItems: 'center' }}>
            <div style={{ display: "flex", flexDirection: "column", }}><p>Mapped</p> <p>Unmapped</p></div>
            <div style={{ display: "flex", flexDirection: "column", padding: "0 4px", alignItems: 'center' }}><p>-</p> <p>-</p></div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: 'center', fontWeight: "600" }}><p>{studentCount[0].mapped_students}</p> <p>{studentCount[0].unmapped_students}</p></div>


          </h6>
        )}

      </div>

      {/* Table */}
      <div
        className="ag-theme-alpine my-2"
        style={{ width: "100%", height: "450px" }}
      >
        <AgGridReact
          defaultColDef={{ flex: 1 }}
          onGridReady={onGridReady}
          columnDefs={columnHeader}
          rowSelection={rowSelectionType}
          onSelectionChanged={onSelectionChanged}
          rowMultiSelectWithClick={true}
          pagination={true}
          paginationPageSize={10}
          paginationAutoPageSize={true}
          sideBar={true}
          components={components}
        // rowModelType={'serverSide'} 
        />
      </div>
    </div>
  );
}

export default UnmappedStudentsTable;
